export const oneTrustIsInitialized = (): boolean =>
    typeof window.OneTrust === 'object' && typeof window.OnetrustActiveGroups === 'string';
